import { Link } from "react-router-dom";
import LoopWatermark from "../../Components/Brand/LoopWatermark";
import { ArrowIcon } from "../../Components/Brand/Icons";
import StationTrack from "../../Components/Track/StationTrack";
import { ABOUT_BELIEFS, ABOUT_FACTS, PRINCIPLES } from "../../content/about";
import Seo from "../../seo/Seo";
import { breadcrumbSchema } from "../../seo/site";
import StackGraphic from "./StackGraphic";
import "./about.css";

const AboutPage = () => (
  <>
    <Seo
      path="/about"
      title="About Us — Software Studio in Kitchener, Ontario | Infinitude Stack"
      description="Infinitude Stack is a Kitchener, Ontario software studio. Strategy, design, engineering, testing, cloud and growth in one team that owns the result."
      schema={[breadcrumbSchema("About", "/about")]}
    />

    <div className="is-about">
      {/* ---------- Hero ---------- */}
      <section className="is-container is-about-hero">
        <div className="is-about-hero__copy">
          <h1 className="is-display is-about-hero__title">
            One team. <strong className="is-accent-text">Every layer of the stack.</strong>
          </h1>
          <p className="is-lede is-about-hero__lede">
            Most businesses juggle an agency for design, a dev shop for code and
            someone else for the cloud. Every hand-off costs time, money and context.
          </p>
          <p className="is-lede is-about-hero__lede">
            Infinitude Stack removes those hand-offs. Strategy, design, engineering,
            testing and growth sit in one team that owns the result — from the first
            conversation to long after launch.
          </p>
        </div>
        <div className="is-about-hero__visual">
          <StackGraphic />
        </div>
      </section>

      {/* ---------- Facts ---------- */}
      <section className="is-container" aria-label="At a glance">
        <ul className="is-about-facts is-reveal">
          {ABOUT_FACTS.map((f) => (
            <li key={f.label} className="is-about-fact">
              <b>{f.value}</b>
              <span>{f.label}</span>
            </li>
          ))}
        </ul>
      </section>

      {/* ---------- Beliefs (dark) ---------- */}
      <section className="is-about-beliefs" aria-label="What we believe">
        <LoopWatermark />
        <div className="is-container is-about-beliefs__grid">
          {ABOUT_BELIEFS.map((b) => (
            <div key={b.eyebrow} className="is-about-belief is-reveal">
              <p className="is-eyebrow">{b.eyebrow}</p>
              <h2 className="is-display">{b.title}</h2>
              <p>{b.text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ---------- Principles ---------- */}
      <section className="is-container is-about-principles" aria-labelledby="about-principles-title">
        <div className="is-section-head is-reveal">
          <div>
            <p className="is-eyebrow">Our principles</p>
            <h2 id="about-principles-title" className="is-display is-h2">
              What we <strong className="is-accent-text">stand for.</strong>
            </h2>
          </div>
        </div>
        <StationTrack items={PRINCIPLES} />
      </section>

      {/* ---------- CTA: rounded navy panel ---------- */}
      <section className="is-about-cta" aria-labelledby="about-cta-title">
        <div className="is-about-cta__panel is-reveal">
          <h2 id="about-cta-title" className="is-display is-about-cta__title">
            Let’s build <strong>what’s next.</strong>
          </h2>
          <Link to="/contact" className="is-btn is-btn--accent">
            Work with us
            <span className="is-btn__arrow">
              <ArrowIcon />
            </span>
          </Link>
        </div>
      </section>
    </div>
  </>
);

export default AboutPage;
